import { render, staticRenderFns } from "./company.vue?vue&type=template&id=07c1a864&"
import script from "./company.vue?vue&type=script&lang=js&"
export * from "./company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HomePageNavbar: require('/workspace/components/HomePage/HomePageNavbar.vue').default,HomePageFooter: require('/workspace/components/HomePage/HomePageFooter.vue').default})
